import React, { Dispatch, SetStateAction } from 'react';
import styled, { css } from 'styled-components';
import { GRAY30 } from 'global-styles';
import { useAnimation } from 'hooks/useAnimation';
import { opacityAppear } from 'components/Home';
import { opacityDisappear } from 'avif-comparison/src/components/AppModal';
import { NavList } from './NavList';

type Props = {
  isScrolled: boolean;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
};

const MobileNavItems = ({ isOpen, setIsOpen }: Props) => {
  const [isVisible, showAnimation] = useAnimation(isOpen, 200);

  if (!isVisible && !showAnimation) return null;

  return (
    <MobileNavItemsContainer
      isVisible={isVisible}
      showAnimation={showAnimation}
    >
      <div className="list-wrapper">
        <NavList setIsOpen={setIsOpen} />
      </div>
    </MobileNavItemsContainer>
  );
};

export default MobileNavItems;

type MobileNavItemsContainerProps = {
  isVisible: boolean;
  showAnimation: boolean;
};

const MobileNavItemsContainer = styled.ul<MobileNavItemsContainerProps>`
  overflow-y: auto;
  position: fixed;
  z-index: 999;
  top: 72px;
  left: 0;
  right: 0;
  bottom: 0;
  color: ${GRAY30};
  background: #fff;
  padding: 32px;
  animation: ${opacityAppear} 0.2s;

  ${({ showAnimation }) =>
    showAnimation &&
    css`
      animation: ${opacityDisappear} 0.2s;
    `};

  @media screen and (max-width: 1439px) {
    top: 64px;
  }
  @media screen and (max-width: 1239px) {
    top: 60px;
  }
  @media screen and (max-width: 600px) {
    top: 56px;
  }
`;
